export default __webpack_public_path__ + "static/media/banner-home.4b8136cb.png";